import { setOrm } from 'common-src/features/orm';
import { syncDashboardV2Appointments } from 'common-src/models/DashboardV2Appointment/sync';
import { syncDashboardV2TaskQueue } from 'common-src/models/DashboardV2Task/sync';
import orm from 'common-src/orm';

import {
  setCareOrchestrationLastFetchedAt,
  setCareOrchestrationMeta,
  setCareOrchestrationStats,
} from 'src/features/careOrchestration';
import { store } from 'src/store';

const getEmbeddedAthenaIntegration = (row) => row?.patient?.athenaIntegration ?? null;
const getEmbeddedZusIntegration = (row) => row?.patient?.zusIntegration ?? null;

const upsertEmbeddedIntegrations = (session, modelName, integrationsById) => {
  if (!integrationsById.size) return;

  const modelClass = session[modelName];
  const modelFields = Object.keys(modelClass.fields);

  integrationsById.forEach((integration) => {
    modelClass.upsert(
      modelFields.reduce((acc, field) => {
        if (integration[field] !== undefined) acc[field] = integration[field];
        return acc;
      }, {}),
    );
  });
};

const syncEmbeddedIntegrations = (dispatch, taskQueueRows = [], appointments = []) => {
  const athenaIntegrationsById = new Map();
  const zusIntegrationsById = new Map();

  [...taskQueueRows, ...appointments].forEach((row) => {
    const integration = getEmbeddedAthenaIntegration(row);
    if (integration?.id) athenaIntegrationsById.set(integration.id, integration);

    const zusIntegration = getEmbeddedZusIntegration(row);
    if (zusIntegration?.id) zusIntegrationsById.set(zusIntegration.id, zusIntegration);
  });

  if (!athenaIntegrationsById.size && !zusIntegrationsById.size) return;

  const rootOrm = store.getState().orm;
  const session = orm.session(rootOrm);
  upsertEmbeddedIntegrations(session, 'PatientIntegrationsAthena', athenaIntegrationsById);
  upsertEmbeddedIntegrations(session, 'PatientIntegrationsZus', zusIntegrationsById);

  dispatch(setOrm(session.state));
};

export const syncCareOrchestrationData = ({
  dispatch,
  taskQueueRows,
  taskQueueMeta,
  appointmentsBody,
  statsBody,
}) => {
  syncDashboardV2TaskQueue({
    data: taskQueueRows,
    meta: taskQueueMeta,
  });
  syncDashboardV2Appointments(appointmentsBody);
  syncEmbeddedIntegrations(dispatch, taskQueueRows, appointmentsBody?.data || []);

  dispatch(setCareOrchestrationStats(statsBody?.data || null));
  dispatch(
    setCareOrchestrationMeta({
      tasks: taskQueueMeta || null,
      appointments: appointmentsBody?.meta || null,
      stats: statsBody?.meta || null,
      readiness: null,
    }),
  );
  dispatch(setCareOrchestrationLastFetchedAt(new Date().toISOString()));
};
